import { Observable } from 'rxjs/Observable';
import { observableRace, observableTimer, rx } from '@shared/rx';
import { Injectable } from '@angular/core';
import { select } from '@angular-redux/store';
import { UiActions } from '@app/store/actions';

@Injectable()
export class ModalLoaderService {
  @select(['ui', 'modalLoader'])
  private readonly isLoading$: Observable<boolean>;

  public constructor(private readonly uiApiActions: UiActions) {}

  public async start(): Promise<void> {
    this.uiApiActions.enableModalLoader();
    await this.waitForLoaderOnScreen();
  }

  public withLoader(fn: () => unknown): void {
    this.start().then(() => {
      fn();
      this.stop();
    });
  }

  public stop(): void {
    this.uiApiActions.disableModalLoader();
  }

  private waitForLoaderOnScreen(): Promise<unknown> {
    const onLoaderShown$ = this.isLoading$.pipe(
      rx.filter(Boolean),
      rx.first(),
      // delay for ui rendering
      rx.delay(0),
    );

    const timeout$ = observableTimer(3000);

    return observableRace(onLoaderShown$, timeout$).toPromise();
  }
}
